module.exports = __webpack_public_path__ + "static/media/img-btn2.65d5f070.png";